import { useQuery } from '@apollo/client';
import { makeUniqueId } from '@apollo/client/utilities';
import { Card, Col, Row } from 'reactstrap';
import { FIND_EMOTIONS_RECORDS_ADMIN } from '../../../../graphql/Query/users';

const Consumption = ({ userId }) => {
  const { data, loading } = useQuery(FIND_EMOTIONS_RECORDS_ADMIN, {
    variables: {
      userId
    }
  });

  const calcPorc = (item) => {
    return item.total > 0 ? ((item.points * 100) / item.total).toFixed(0) : 0;
  };

  if (loading) {
    return null;
  }
  return (
    <Card body>
      <Row className="p-2">
        <Col
          md={12}
          className="text-center mb-3"
          style={{
            color: '#6D6B7B',
            fontSize: 15,
            fontWeight: 'bold'
          }}
        >
          Consumo por Emociones
        </Col>
        {data.findEmotionsRecordAdmin.map((item) => (
          <Col
            className="d-flex justify-content-between align-items-center mb-1"
            key={makeUniqueId(Date.now())}
            md={12}
          >
            <div
              style={{
                color: '#6D6B7B'
              }}
            >
              {item.tag}
            </div>
            <div
              style={{
                color: '#6D6B7B'
              }}
            >
              {calcPorc(item)}%
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default Consumption;
